import React from "react";
import styled from "styled-components";
import i18n from "i18next";
import { SHARE_CHALLENGE_OVERLAY_ID, isAppInViewMode, isAppInProofViewMode } from "@kubera/common";

const Backdrop = styled.div`
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  align-items: center;
  justify-content: center;
  z-index: 10001;
`;

const Panel = styled.div`
  background: #ffffff;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const Prompt = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #101010;
`;

const ShareChallengeOverlay = () => {
  if (isAppInViewMode() === false && isAppInProofViewMode() === false) {
    return null;
  }
  return (
    <Backdrop id={SHARE_CHALLENGE_OVERLAY_ID}>
      <Panel>
        <Prompt>{i18n.t("shareChallengeVerifyPrompt")}</Prompt>
        <div id="html_element" />
      </Panel>
    </Backdrop>
  );
};

export default ShareChallengeOverlay;
